import React, { FC } from "react";
import Copy from "../../../../../images/products/copy.svg";
import Add from "../../../../../images/products/plus.svg";
import {
  CustomLabel,
  FlexContainer,
  IconButton,
} from "@mindmemobile/mm-shared-global";
import { HeaderSection } from "../styles";

interface IProps {
  header: string;
  subHeader?: string;
  showCopyButton?: boolean;
  showPriceButton?: boolean;
  onCopyClick?: () => void;
  onAddPriceClick?: () => void;
}

const ItemHeader: FC<IProps> = ({
  header,
  subHeader,
  showCopyButton,
  showPriceButton,
  onAddPriceClick,
  onCopyClick,
}) => {
  return (
    <HeaderSection>
      <div>
        <CustomLabel fontSize="30px" fontWeight="700" lineHeight="32px">
          {header}
        </CustomLabel>
        {subHeader && (
          <CustomLabel fontSize="14px" margin="10px 0px 0px">
            {subHeader}
          </CustomLabel>
        )}
      </div>
      {(showPriceButton || showCopyButton) && (
        <div>
          <FlexContainer spacing={15}>
            {showPriceButton && (
              <IconButton onClick={() => onAddPriceClick && onAddPriceClick()}>
                <img src={Add} alt="" />
                <label htmlFor="">New Price</label>
              </IconButton>
            )}
            {showCopyButton && (
              <IconButton onClick={() => onCopyClick && onCopyClick()} className="copy-button-with-icon">
                <img src={Copy} alt="copy" />
                <label htmlFor="">Copy from Another Item</label>
              </IconButton>
            )}
          </FlexContainer>
        </div>
      )}
    </HeaderSection>
  );
};

export default ItemHeader;
